import { BaseOdataUrl, BaseApiUrl } from '../../../configVariables';
import {
    ODataResult,
    ReportModel,
    ReportParametersInputModel,
} from '../../../model';
import apiClient from '../../../utils/apiClient';
import { ReportTypeRequest } from '../../../model/ReportTypeRequest';

export const fetchReports = async (query?: string) => {
    const url = `${BaseOdataUrl}/reporting${query}`;
    const result = await apiClient.get<ODataResult<ReportModel[]>>(url);
    return result.data;
};

export const createReport = async (
    data: ReportParametersInputModel
): Promise<boolean> => {
    const url = `${BaseApiUrl}/reporting`;

    var resp = await apiClient.post(url, data, {
        errorResponseHandler: (resp, defaultHandler) => {
            if (resp.status === 409) {
                return Promise.resolve(true);
            }

            return defaultHandler(resp);
        },
    });

    return resp.status !== 409;
};

export const cancelReport = async (id: string) => {
    const url = `${BaseApiUrl}/reporting/${id}`;
    await apiClient.delete(url);
};

export const canAccessReport = async (params: {
    reportType: ReportTypeRequest;
    allTeams?: boolean;
}) => {
    const url = `${BaseApiUrl}/permissions/canAccessReport`;

    return await apiClient.get<boolean>(url, { query: params });
};
